module.exports = require("./../../_gen/starling/events/Event");